var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstelle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 214 341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #000;\n        stroke-width: 3.4px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3, .cls-4 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-5 {\n        fill: #f4b497;\n      }\n\n      .cls-6 {\n        fill: #414a4c;\n      }\n\n      .cls-7 {\n        fill: #373db0;\n      }\n\n      .cls-8 {\n        fill: #ee927e;\n      }\n\n      .cls-9 {\n        fill: #f6c09c;\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-3 {\n        stroke: #033040;\n        stroke-width: 24.93px;\n      }\n\n      .cls-12 {\n        fill: #fff;\n      }\n\n      .cls-13 {\n        fill: #000d19;\n      }\n\n      .cls-14 {\n        fill: #f8c79d;\n      }\n\n      .cls-15 {\n        fill: #073f4a;\n      }\n\n      .cls-16 {\n        fill: #556ec9;\n      }\n\n      .cls-17 {\n        fill: #fa98be;\n      }\n\n      .cls-4 {\n        stroke: #000d19;\n        stroke-width: 2.27px;\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-19 {\n        fill: #002131;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M88.94,136.85h24.34c7.19,0,13.02,5.83,13.02,13.02v4.3c0,3.88-3.15,7.02-7.02,7.02h-36.34c-3.88,0-7.02-3.15-7.02-7.02v-4.3c0-7.19,5.83-13.02,13.02-13.02Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M144.93,99.59h-19.56c-4.04,0-6.4-4.56-4.07-7.85l1.43-2.02c6.06-8.57,18.78-8.57,24.84,0l1.43,2.02c2.33,3.3-.03,7.85-4.07,7.85Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M87.37,99.59h19.56c4.04,0,6.4-4.56,4.07-7.85l-1.43-2.02c-6.06-8.57-18.78-8.57-24.84,0l-1.43,2.02c-2.33,3.3.03,7.85,4.07,7.85Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 97,
    cy: 296.5,
    rx: 52,
    ry: 21.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.05,26.08h40.67c11.81,0,21.4,9.59,21.4,21.4v103.19c0,20.04-16.27,36.3-36.3,36.3h-26.52c-20.04,0-36.3-16.27-36.3-36.3V63.14c0-20.45,16.61-37.06,37.06-37.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 110.5,
    y: 133.42,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(238.33 320.12) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 110.5,
    y: 169.35,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(238.33 391.98) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 124.85,
    cy: 214.61,
    r: 14.34
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 83.89,
    y: 158.41,
    width: 34.43,
    height: 26.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M88.94,136.85h24.34c7.19,0,13.02,5.83,13.02,13.02v4.3c0,3.88-3.15,7.02-7.02,7.02h-36.34c-3.88,0-7.02-3.15-7.02-7.02v-4.3c0-7.19,5.83-13.02,13.02-13.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M87.44,136.85h32.49v5.77c0,4.73-3.84,8.57-8.57,8.57h-15.35c-4.73,0-8.57-3.84-8.57-8.57v-5.77h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.95,177.23h18.3c12.37,0,22.42,10.05,22.42,22.42v9.49h-63.14v-9.49c0-12.37,10.05-22.42,22.42-22.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 83.89,
    y: 174.21,
    width: 34.43,
    height: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M75.69,302.59l-3.48-9.16c-3.14-8.28,2.97-17.14,11.83-17.14h0c8.86,0,14.97,8.86,11.83,17.14l-3.48,9.16c-2.92,7.69-13.79,7.69-16.71,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 83.89,
    y: 159.74,
    width: 34.43,
    height: 8.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M76.43,280.71h15.23v6.67c0,2.85-2.31,5.16-5.16,5.16h-4.91c-2.85,0-5.16-2.31-5.16-5.16v-6.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.04,260.79c-8.01,0-14.5-6.49-14.5-14.5v-41.11c0-8.01,6.49-14.5,14.5-14.5s14.5,6.49,14.5,14.5v41.11c0,8.01-6.49,14.5-14.5,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M69.54,287.41v-41.11c0-8.01,6.49-14.5,14.5-14.5s14.5,6.49,14.5,14.5v41.11h-29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 71.39,
    y: 149.22,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 71.39,
    y: 185.15,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 74.37,
    cy: 230.41,
    r: 14.34
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M109.84,289.91l-3.48-9.16c-3.14-8.28,2.97-17.14,11.83-17.14h0c8.86,0,14.97,8.86,11.83,17.14l-3.48,9.16c-2.92,7.69-13.79,7.69-16.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M110.57,268.04h15.23v6.67c0,2.85-2.31,5.16-5.16,5.16h-4.91c-2.85,0-5.16-2.31-5.16-5.16v-6.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M118.19,251.3c-8.01,0-14.5-6.49-14.5-14.5v-41.11c0-8.01,6.49-14.5,14.5-14.5s14.5,6.49,14.5,14.5v41.11c0,8.01-6.49,14.5-14.5,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M103.69,274.73v-41.11c0-8.01,6.49-14.5,14.5-14.5s14.5,6.49,14.5,14.5v41.11h-29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.63,178.21c-.71-.71-1.86-.71-2.57,0s-.71,1.86,0,2.57l2.57,2.57,2.57-2.57c.71-.71.71-1.86,0-2.57s-1.86-.71-2.57,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.57,178.21c-.71-.71-1.86-.71-2.57,0s-.71,1.86,0,2.57l2.57,2.57,2.57-2.57c.71-.71.71-1.86,0-2.57s-1.86-.71-2.57,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.7,178.21c-.71-.71-1.86-.71-2.57,0s-.71,1.86,0,2.57l2.57,2.57,2.57-2.57c.71-.71.71-1.86,0-2.57s-1.86-.71-2.57,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M103.69,189.07h4.6v11.24c0,2.54-2.06,4.6-4.6,4.6h0v-15.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M96.82,17.29h13.74c21.52,0,38.99,17.47,38.99,38.99v29.67c0,8.75-7.1,15.85-15.85,15.85h-60.03c-8.75,0-15.85-7.1-15.85-15.85v-29.67c0-21.52,17.47-38.99,38.99-38.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M91.48,45.33h38.77c11.66,0,21.12,9.47,21.12,21.12v39.74c0,18.71-15.19,33.9-33.9,33.9h-13.21c-18.71,0-33.9-15.19-33.9-33.9v-39.74c0-11.66,9.47-21.12,21.12-21.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 91.4,
    y: 121.71,
    width: 19.4,
    height: 22.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M118.2,94.72l7.34,20.73c.63,1.77-.69,3.64-2.57,3.64h-3.27c-2.03,0-3.68-1.65-3.68-3.68v-20.31c0-1.26,1.75-1.56,2.17-.37Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M144.93,99.59h-19.56c-4.04,0-6.4-4.56-4.07-7.85l1.43-2.02c6.06-8.57,18.78-8.57,24.84,0l1.43,2.02c2.33,3.3-.03,7.85-4.07,7.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 132.75,
    y: 87.66,
    width: 14.31,
    height: 24.01,
    rx: 7.15,
    ry: 7.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 131.21,
    y: 85.1,
    width: 6.15,
    height: 11.21,
    rx: 3.07,
    ry: 3.07
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.86,92.49s4.82-9.2,14.29-9.2c10.31,0,14.28,9.2,14.28,9.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 147.81,
    y1: 83.01,
    x2: 144.58,
    y2: 86.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 142.86,
    y1: 80.02,
    x2: 140.82,
    y2: 84.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 151.76,
    y1: 86.73,
    x2: 148.08,
    y2: 89.73
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M87.37,99.59h19.56c4.04,0,6.4-4.56,4.07-7.85l-1.43-2.02c-6.06-8.57-18.78-8.57-24.84,0l-1.43,2.02c-2.33,3.3.03,7.85,4.07,7.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 94.37,
    y: 87.66,
    width: 14.31,
    height: 24.01,
    rx: 7.15,
    ry: 7.15,
    transform: "translate(203.06 199.33) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 92.68,
    y: 85.1,
    width: 6.15,
    height: 11.21,
    rx: 3.07,
    ry: 3.07,
    transform: "translate(191.52 181.42) rotate(180)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.44,92.49s-4.82-9.2-14.29-9.2c-10.31,0-14.28,9.2-14.28,9.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.49,
    y1: 83.01,
    x2: 87.72,
    y2: 86.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 89.44,
    y1: 80.02,
    x2: 91.48,
    y2: 84.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.54,
    y1: 86.73,
    x2: 84.22,
    y2: 89.73
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M144.9,94.08h11.48v2.31c0,7.24-5.88,13.12-13.12,13.12h0c-2.77,0-5.02-2.25-5.02-5.02v-3.76c0-3.67,2.98-6.66,6.66-6.66Z",
    transform: "translate(294.63 203.59) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M80.44,94.08h0c7.24,0,13.12,5.88,13.12,13.12v2.31h-11.48c-3.67,0-6.66-2.98-6.66-6.66v-3.76c0-2.77,2.25-5.02,5.02-5.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 81.71,
    cy: 107.01,
    r: 7.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.33,51.5h-9.16c-15.4,0-27.88,12.48-27.88,27.88v87.59"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 150.59,
    cy: 107.01,
    r: 7.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M116.66,126.99s-1.72-3.77-6.99-6.04c-5.26-2.27-9.43-.48-9.43-.48,0,0,1.52,4.1,7.15,6.38,4.02,1.63,9.27.15,9.27.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.85,51.5h9.16c15.4,0,27.88,12.48,27.88,27.88v87.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.12,117.91c2.44,7.8,10.74,12.15,18.54,9.71"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstelle1);
export default __webpack_public_path__ + "static/media/estelle_1.5ea89096fdd3a13c45a23238cf83a019.svg";
export { ForwardRef as ReactComponent };